import type { ShortcutKey } from "skedyul-ui/ui";

/** ⌥N / Alt+N — avoids browser-reserved ⌘N (new window). */
export const NEW_THREAD_SHORTCUT_KEYS: ShortcutKey[] = ["alt", "n"];

export function getNewThreadHref(subdomain: string): string {
  return `/${subdomain}/threads/new`;
}
